import { MdOutlineHomeWork } from "react-icons/md";
import { PLACE_OF_BUSSINESS_TYPE } from "./types.global";
import { FaCarSide } from "react-icons/fa";
import { IoIosWarning } from "react-icons/io";
import { Icon } from "@chakra-ui/react";
import { BsFillBoxSeamFill } from "react-icons/bs";

export const getPlaceOfBusinessIconByType = (type: PLACE_OF_BUSSINESS_TYPE) => {
    switch(type) {
        case PLACE_OF_BUSSINESS_TYPE.DEPOSIT:
            return <MdOutlineHomeWork className="m-2 w-[25px] h-[25px]"/>
        case PLACE_OF_BUSSINESS_TYPE.INTERMEDARY:
            return <FaCarSide className="m-2 w-[25px] h-[25px]"/>
        default:            
            return <IoIosWarning className="m-2 w-[25px] h-[25px]"/>
    }
}


export const getPlaceOfBusinessIconByTypeForInventories = (type: PLACE_OF_BUSSINESS_TYPE) => {
    switch(type) {
        case PLACE_OF_BUSSINESS_TYPE.DEPOSIT:
            return  <Icon as={BsFillBoxSeamFill} color='teal.400' w={70} h={70} />
        case PLACE_OF_BUSSINESS_TYPE.INTERMEDARY:
            return  <Icon as={FaCarSide} color='teal.400' w={70} h={70} />
        default:            
            return  <Icon as={IoIosWarning} color='teal.400' w={70} h={70} />
    }
}